import qs from 'qs'

/**
 *
 * @param {String} url Destination url
 * @param {Object} queryParamsJson key values for query string params
 * @param {Object} options key values for window.open options
 * @param {Boolean} defaultQueryParams if true (default) add navOrigin=statistics to querystring
 */
export function openBrowserPopup(
  url,
  queryParamsJson = {},
  options = {},
  defaultQueryParams = true
) {
  const defaultOptions = {
    windowParams: {
      toolbar: 0,
      scrollbars: 1,
      location: 0,
      status: 1,
      menubar: 0,
      resizable: 1,
      width: 800,
      height: 700
    },
    target: '_blank'
  }
  const opt = {
    ...defaultOptions,
    ...options
  }

  const winParams = Object.entries(opt.windowParams)
    .map(([k, v]) => `${k}=${v}`)
    .join(',')

  const queryParams = {
    ...defaultQueryParams,
    ...(queryParamsJson || {})
  }

  const queryString = qs.stringify(queryParams)

  const win = window.open(
    `${url}${queryString.length ? '?' : ''}${queryString}`,
    opt.target,
    winParams
  )
  win.focus()
}
